import { render, staticRenderFns } from "./Transformacao.vue?vue&type=template&id=315b61b0&"
import script from "./Transformacao.vue?vue&type=script&lang=js&"
export * from "./Transformacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports